<div *ngIf="policyLoading" class="text-center py-4">
    <div class="spinner-border text-primary"></div>
    <p class="mt-2 text-muted">Cargando política…</p>
</div>

<div *ngIf="!policyLoading && policyNotSeeded" class="alert alert-warning">
    <i class="fa fa-exclamation-triangle me-2"></i>
    <strong>Configuración no sembrada.</strong>
    Ejecute <code>node seed_approval_policy.js</code> en kredit-api-MT.
</div>

<div *ngIf="!policyLoading && !policyNotSeeded && policyData" class="card">
    <div class="card-body">
        <div class="row mb-3">
            <div class="col-md-6">
                <label class="form-label fw-bold">Modo actual</label>
                <select class="form-select" [(ngModel)]="selectedMode" [disabled]="policySaving">
                    <option *ngFor="let m of policyData.availableModes" [value]="m">
                        {{ getPolicyModeLabel(m) }}
                    </option>
                </select>
                <small class="form-text text-muted d-block mt-2">
                    {{ getPolicyModeDescription(selectedMode) }}
                </small>
            </div>

            <div class="col-md-6" *ngIf="policyData.mode === 'ALTERNATING_ROTATION'">
                <label class="form-label fw-bold">Estado de rotación</label>
                <div class="bg-light p-3 rounded">
                    <div><strong>Último ganador:</strong> {{ policyData.rotationState?.lastWinner || '—' }}</div>
                    <div><strong>Próximo turno:</strong> <span class="badge bg-primary">{{ getNextRotationWinner() || '—' }}</span></div>
                    <div class="mt-1"><small class="text-muted">Última rotación: {{ policyData.rotationState?.lastRotationAt | date:'dd/MM/yyyy HH:mm:ss' }}</small></div>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <small class="text-muted">
                    Última modificación:
                    <strong>{{ policyData.updatedBy || '—' }}</strong>
                    el <strong>{{ policyData.updatedAt | date:'dd/MM/yyyy HH:mm' }}</strong>
                </small>
            </div>
        </div>

        <button class="btn btn-primary"
                (click)="savePolicyMode()"
                [disabled]="policySaving || !selectedMode || selectedMode === policyData.mode">
            <span *ngIf="policySaving" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!policySaving" class="fa fa-save me-1"></i>
            Guardar cambio
        </button>
    </div>
</div>
